import { NgModule } from "@angular/core";
import { LorenUserProfileComponent } from "./components/loren-user-profile/loren-user-profile.component";
import { LorenUserProfileRoutingModule } from "./loren-user-profile-routing.module";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { LorenEntityFormModule } from "../../shared/modules/loren-entity-form/loren-entity-form.module";
import { LorenCardModule } from "../../shared/modules/loren-card/loren-card.module";

import { LorenKeyValueControlModule } from "../../shared/modules/loren-key-value-control/loren-key-value-control.module";
import { LorenFileUploadModule } from "../../shared/modules/loren-file-upload/loren-file-upload.module";
import { LorenImageCropperDialogModule } from "../../shared/modules/loren-image-cropper-dialog/loren-image-cropper-dialog.module";
import { TranslocoModule } from "@jsverse/transloco";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatInputModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    TranslocoModule,

    LorenUserProfileRoutingModule,
    LorenEntityFormModule,
    LorenCardModule,
    LorenKeyValueControlModule,
    LorenFileUploadModule,
    LorenImageCropperDialogModule,

    LorenPageContentComponent,
    LorenUserProfileComponent,
  ],
})
export class LorenUserProfileModule {}
